import { TrialRegionStatus } from '../constants/TrialRegionStatus';
import { EnrollmentStatusActionType, EnrollmentStatusActions } from '../actions/enrollmentStatus/types/actions';
import { EnrollmentState } from '../actions/enrollmentStatus/types/state';
import { ErrorTypes } from '../constants/errorTypes';

export const initialState: EnrollmentState = {
  status: TrialRegionStatus.IDLE,
  list: [],
  error: ErrorTypes.GENERIC
};

const enrollmentStatusReducer = (
  state: EnrollmentState = initialState,
  action: EnrollmentStatusActions,
): EnrollmentState => {
  switch (action.type) {
    case EnrollmentStatusActionType.FetchEnrollmentStatus:
      return { ...state, status: TrialRegionStatus.PENDING };
    case EnrollmentStatusActionType.FetchEnrollmentStatusResolved:
      return {
        ...state,
        list: action.payload,
        status: TrialRegionStatus.RESOLVED
      };
    case EnrollmentStatusActionType.FetchEnrollmentStatusRejected:
      return {
        ...state,
        status: TrialRegionStatus.REJECTED,
        error: action.payload.error,
      };

    default:
      return state;
  }
};

export default enrollmentStatusReducer;
